import { render, staticRenderFns } from "./MainContact.vue?vue&type=template&id=d6da862c&scoped=true"
import script from "./MainContact.vue?vue&type=script&lang=js"
export * from "./MainContact.vue?vue&type=script&lang=js"
import style0 from "./MainContact.vue?vue&type=style&index=0&id=d6da862c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6da862c",
  null
  
)

export default component.exports